export default __webpack_public_path__ + "static/media/st_vincent.1883d88c.jpg";